export default {
  masterItems(state) {
    return state.masterItems;
  },
  dashboardData(state) {
    return state.dashboardData;
  },
  reportData(state) {
    return state.reportData;
  },
};
